import * as logger from '../logging/logger';

const getClientCredentials = () => {
    if (window.pmSecurityExtension) {
        return pmSecurityExtension.getClientCredentials();
    } else {
        logger.log('Error', 'pmSecurityExtension namespace not available');
        return ':';
    }
};
export default getClientCredentials;
